export const IMPERSONATION_STORAGE_KEY = 'brandscapes-impersonation';

export interface StoredSessionTokens {
  accessToken: string;
  refreshToken: string;
}

export interface ImpersonationState {
  adminUserId: string;
  adminEmail: string;
  adminSession: StoredSessionTokens;
  adminReturnPath: string;
  targetUserId: string;
  targetEmail: string;
  targetName?: string;
  startedAt: string;
}

export const readImpersonationState = (): ImpersonationState | null => {
  try {
    const rawState = window.localStorage.getItem(IMPERSONATION_STORAGE_KEY);
    if (!rawState) {
      return null;
    }

    return JSON.parse(rawState) as ImpersonationState;
  } catch (error) {
    console.error('Failed to parse impersonation state:', error);
    clearImpersonationState();
    return null;
  }
};

export const writeImpersonationState = (state: ImpersonationState) => {
  window.localStorage.setItem(IMPERSONATION_STORAGE_KEY, JSON.stringify(state));
};

export const clearImpersonationState = () => {
  window.localStorage.removeItem(IMPERSONATION_STORAGE_KEY);
};
